import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSparklesTwo: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sparkles-two, ai 2 stars, sparkles, ✨"><path fillRule="evenodd" clipRule="evenodd" d="M12 6.5C8.18056 6.5 6.5 8.18056 6.5 12C6.5 8.18056 4.81944 6.5 1 6.5C4.81944 6.5 6.5 4.81944 6.5 1C6.5 4.81944 8.18056 6.5 12 6.5Z" stroke="currentColor" strokeWidth="1.5"/><path fillRule="evenodd" clipRule="evenodd" d="M23 15C17.4444 15 15 17.4444 15 23C15 17.4444 12.5556 15 7 15C12.5556 15 15 12.5556 15 7C15 12.5556 17.4444 15 23 15Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconSparklesTwo;
